import type { Status } from "@shared/types/models";

const STATUS_COLORS: Record<Status, string> = {
  PENDING: "bg-warning/12 text-warning",
  PROCESSING: "bg-info/12 text-info",
  PAID: "bg-brand-purple/12 text-brand-purple",
  COMPLETED: "bg-success/12 text-success",
  FAILED: "bg-destructive/12 text-destructive",
  SKIPPED: "bg-muted text-muted-foreground",
};

const STATUS_BADGE_VARIANTS: Record<Status, "paid" | "success" | "warning" | "info" | "secondary" | "destructive"> = {
  PENDING: "warning",
  PROCESSING: "info",
  PAID: "paid",
  COMPLETED: "success",
  FAILED: "destructive",
  SKIPPED: "secondary",
};

const styles = {
  container: "p-4 sm:p-6",

  filtersBar: "mb-4 rounded-xl border border-border bg-card shadow-sm p-3 sm:p-4 grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4",
  filterGroup: "flex flex-col gap-1.5",
  filterLabel: "text-xs font-semibold uppercase tracking-wider text-muted-foreground",
  filterInput:
    "rounded-md border border-input px-2.5 py-1.5 text-sm bg-background text-foreground placeholder:text-muted-foreground/60 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",

  chipWrapper: "flex flex-wrap gap-1.5",
  chipLabel: "text-xs font-medium text-muted-foreground block mb-1.5",
  chip: "rounded-full px-3 py-1 text-xs font-medium border border-border cursor-pointer transition-colors",
  chipActive: "bg-primary text-primary-foreground border-primary",
  chipInactive: "bg-background text-muted-foreground border-border hover:bg-accent",

  clearAllBtn: "text-xs text-muted-foreground hover:text-foreground transition-colors inline-flex items-center gap-1",

  pageSizeBar: "mb-3 flex items-center gap-2",
  pageSizeSelect: "rounded-md border border-input px-2 py-1 text-sm bg-background text-foreground",

  sortable: "cursor-pointer select-none hover:bg-accent/50 transition-colors",
  sortIcon: "ml-1 inline-flex items-center gap-0.5",
  sortIconAsc: "h-3 w-3 text-primary",
  sortIconDesc: "h-3 w-3 text-primary",
  sortIconInactive: "h-3 w-3 text-muted-foreground",

  loadingItem: "h-12 animate-shimmer rounded-lg bg-muted",
  emptyState: "py-16 text-center text-muted-foreground",
  emptyIcon: "mx-auto h-14 w-14 text-muted-foreground/50",
  emptyIconWrapper: "animate-scale-in",
  emptyText: "mt-3 text-base font-medium text-foreground",
  emptyHint: "mt-1 text-sm text-muted-foreground max-w-md mx-auto",

  tableContainer: "overflow-x-auto rounded-xl border border-border bg-card shadow-sm",
  table: "min-w-full",
  thead: "bg-secondary/50",
  th: "px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground",
  tbody: "",
  row: "border-b border-border last:border-b-0 transition-colors hover:bg-secondary/50",
  rowEven: "bg-secondary/20",
  td: "whitespace-nowrap px-4 py-3 text-sm",
  tdPrimary: "text-foreground font-medium",
  tdAmount: "text-sm font-bold text-foreground tabular-nums",
  actionBtn: "inline-flex items-center justify-center rounded-md p-1.5 text-muted-foreground hover:text-foreground hover:bg-accent transition-colors",

  pagination: "mt-4 flex flex-col sm:flex-row items-center justify-between gap-3",
  paginationButtons: "flex items-center gap-1.5",
  paginationButton:
    "inline-flex items-center justify-center rounded-md border border-border px-3 py-1.5 text-sm font-medium disabled:opacity-50 disabled:pointer-events-none hover:bg-accent hover:text-accent-foreground transition-colors",
  paginationButtonActive: "bg-primary text-primary-foreground border-primary hover:bg-primary/90",

  cardRow: "block sm:hidden rounded-xl border border-border bg-card p-4 shadow-sm transition-colors hover:bg-accent/50",
  cardField: "flex items-center justify-between text-sm mb-1.5 last:mb-0",
  cardLabel: "text-xs font-medium text-muted-foreground",
  cardValue: "text-foreground",
};

export { STATUS_BADGE_VARIANTS, STATUS_COLORS, styles };
